export enum Actions {
  CREATE = 1,
  EDIT,
  FILTER,
  EXPORT,
  SELECT,
  DELETE,
}

export enum PageTypes {
  INDEX = "index",
  CREATE = "create",
  EDIT = "edit",
  SHOW = "show",
  REPORT = "report",
  ERROR = "error",
  ARCHIVED = "archived",
  DELETE = "delete",
}

export enum B360ToastType {
  SUCCESS = "success",
  ERROR = "error",
  WARNING = "warning",
  PENDING = "pending",
}
